<div class="space-y-6">
  <!-- Section Adresse professionnelle -->
  <div class="space-y-4">
    <span class="text-xs font-bold text-neutral-12 uppercase tracking-wider flex items-center gap-2">
      <mat-icon class="!w-4 !h-4 !text-base text-primary-9">place</mat-icon>
      Adresse professionnelle de réception
    </span>

    @if (officialAddress()) {
      <!-- Choix de la source d'adresse -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <button
          type="button"
          class="p-3.5 rounded-xl border text-left flex flex-col gap-1.5 transition-all cursor-pointer"
          [class.bg-primary-1]="!currentUseCustom()"
          [class.border-primary-6]="!currentUseCustom()"
          [class.shadow-xs]="!currentUseCustom()"
          [class.bg-neutral-1]="currentUseCustom()"
          [class.dark:bg-neutral-2]="currentUseCustom()"
          [class.border-neutral-3]="currentUseCustom()"
          [class.dark:border-neutral-4]="currentUseCustom()"
          (click)="toggleUseCustom(false)"
        >
          <div class="flex items-center justify-between">
            <span class="text-xs font-bold text-neutral-12 flex items-center gap-1.5">
              <mat-icon class="!w-4 !h-4 !text-base" [class.text-primary-11]="!currentUseCustom()"
                >badge</mat-icon
              >
              Adresse officielle carte T
            </span>
            @if (!currentUseCustom()) {
              <span class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-primary-2 text-primary-11"
                >Active</span
              >
            }
          </div>
          <p class="text-xs text-neutral-11 leading-relaxed">
            {{ officialAddress() }}
          </p>
        </button>

        <button
          type="button"
          class="p-3.5 rounded-xl border text-left flex flex-col gap-1.5 transition-all cursor-pointer"
          [class.bg-primary-1]="currentUseCustom()"
          [class.border-primary-6]="currentUseCustom()"
          [class.shadow-xs]="currentUseCustom()"
          [class.bg-neutral-1]="!currentUseCustom()"
          [class.dark:bg-neutral-2]="!currentUseCustom()"
          [class.border-neutral-3]="!currentUseCustom()"
          [class.dark:border-neutral-4]="!currentUseCustom()"
          (click)="toggleUseCustom(true)"
        >
          <div class="flex items-center justify-between">
            <span class="text-xs font-bold text-neutral-12 flex items-center gap-1.5">
              <mat-icon class="!w-4 !h-4 !text-base" [class.text-primary-11]="currentUseCustom()"
                >edit_location_alt</mat-icon
              >
              Adresse personnalisée
            </span>
            @if (currentUseCustom()) {
              <span class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-primary-2 text-primary-11"
                >Personnalisée</span
              >
            }
          </div>
          <p class="text-xs text-neutral-10 leading-relaxed">
            Définissez une adresse de permanence, d'agence locale ou de coworking différente de la carte T.
          </p>
        </button>
      </div>
    }

    <!-- Champs d'adresse personnalisée -->
    @if (currentUseCustom() || !officialAddress()) {
      <div
        class="p-4 bg-neutral-2/50 dark:bg-neutral-3/50 rounded-xl border border-neutral-3 dark:border-neutral-4 space-y-3"
      >
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>N° de voie</mat-label>
            <input
              matInput
              aria-label="Numéro de voie"
              placeholder="Ex : 12 bis"
              [value]="currentAddress().streetNumber || ''"
              (input)="onFieldChange('streetNumber', $any($event.target).value)"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>Type de voie</mat-label>
            <input
              matInput
              aria-label="Type de voie"
              placeholder="Ex : Rue, Avenue, Boulevard"
              [value]="currentAddress().streetType || ''"
              (input)="onFieldChange('streetType', $any($event.target).value)"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full sm:col-span-1" subscriptSizing="dynamic">
            <mat-label>Nom de la voie</mat-label>
            <input
              matInput
              aria-label="Nom de la voie"
              placeholder="Ex : de la Paix"
              [value]="currentAddress().streetName || ''"
              (input)="onFieldChange('streetName', $any($event.target).value)"
            />
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>Code postal</mat-label>
            <input
              matInput
              aria-label="Code postal"
              placeholder="Ex : 75002"
              [value]="currentAddress().zipCode || ''"
              (input)="onFieldChange('zipCode', $any($event.target).value)"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>Commune</mat-label>
            <input
              matInput
              aria-label="Commune"
              placeholder="Ex : Paris"
              [value]="currentAddress().city || ''"
              (input)="onFieldChange('city', $any($event.target).value)"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>Complément (bâtiment, étage...)</mat-label>
            <input
              matInput
              aria-label="Complément d'adresse"
              placeholder="Ex : Étage 2, Porte gauche"
              [value]="currentAddress().complement || ''"
              (input)="onFieldChange('complement', $any($event.target).value)"
            />
          </mat-form-field>
        </div>
      </div>
    }
  </div>

  <!-- Composant standard d'horaires d'ouverture -->
  <aura-opening-hours-form [hours]="currentHours()" (hoursChange)="onHoursChange($event)" />
</div>
